class BundleBuilder extends Accordion {
    constructor() {
        super();

        this.bundlePreference = this.dataset.bundlePreference;
        this.accordionList = this.querySelector('.js-accordion-list');
        this.accordionItems = this.querySelectorAll('.js-accordion-item');
        this.builderOptions = this.querySelectorAll('.js-builder-option');
        this.builderForm = this.querySelector('.js-builder-form');
        this.builderFormAddToCartButton = this.querySelector('.js-bundle-add');
        this.builderError = this.querySelector('.js-bundle-error');
        this.cart = document.querySelector('cart-drawer');

        if (!this.accordionItems) {
            this.handleError('No bundle options configured');
            return;
        }

        if (!this.builderOptions) {
            this.handleError('No bundle products configured');
            return;
        }

        if (!this.builderForm || !this.builderFormAddToCartButton) {
            this.handleError('No form tag or add to cart button to submit');
            return;
        }

        this.config = {
            total: [...this.accordionItems].length,
        };

        this.selectedItems = Object.fromEntries(
            Array.from({ length: this.config.total }, (_, i) => [
                i + 1,
                {
                    index: i,
                    title: undefined,
                    id: undefined,
                },
            ]),
        );

        this.builderOptions.forEach((builderOption) => {
            builderOption.addEventListener('click', this.handleSelection.bind(this));
        });

        this.builderForm.addEventListener('submit', this.handleFormSubmission.bind(this));
    }

    generateUniqueRequestId() {
        const timestamp = Date.now(); // milliseconds since epoch
        const random = Math.random().toString(36).substring(2, 9); // random string
        return `req_${timestamp}_${random}`;
    }

    async processProducts(callback) {
        const shouldIncludeProduct = this.dataset.includeProduct === 'true';
        const selectedItemKeys = Object.keys(this.selectedItems);
        const formData = new FormData(this.builderForm);
        const formId = parseInt(formData.get('id'));
        const formQuantity = parseInt(formData.get('quantity'));
        const __dvBundleId = this.generateUniqueRequestId();
        const __dvBundlePreference = this.bundlePreference;

        const items = [];

        // Required properies for the bundling from the cart transform
        const additionalProperies = {
            __dvBundleId,
            __dvBundlePreference,
        };

        // Include the products within the bundle - flatten by ID and sum quantities
        const productQuantities = {};
        selectedItemKeys.forEach((key) => {
            const id = parseInt(this.selectedItems[key].id);
            if (productQuantities[id]) {
                productQuantities[id] += formQuantity;
            } else {
                productQuantities[id] = formQuantity;
            }
        });

        // Convert flattened quantities back to items array
        Object.entries(productQuantities).forEach(([id, quantity]) => {
            items.push({
                id: parseInt(id),
                quantity,
                properties: additionalProperies,
            });
        });

        // Include the original product in the form
        if (shouldIncludeProduct)
            items.push({
                id: formId,
                quantity: formQuantity,
                properties: additionalProperies,
            });

        // Sections for cart render
        const sectionProperties = {};
        if (this.cart) {
            sectionProperties['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
            sectionProperties['sections_url'] = window.location.pathname;
        }

        this.toggleLoadingSpinnerVisibility();

        try {
            const response = await fetch(`${window.routes.cart_add_url}.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items,
                    ...sectionProperties,
                }),
            });

            if (response.status != 200) throw new Error(`Recieved a ${response.status} response`);

            const data = await response.json();

            if (callback) callback(data);
        } catch (error) {
            this.handleError(error);
        } finally {
            this.toggleLoadingSpinnerVisibility();
        }
    }

    toggleLoadingSpinnerVisibility() {
        this.builderFormAddToCartButton.classList.toggle('product-builder__action--loading');
    }

    updateUI() {
        const selectedItemKeys = Object.keys(this.selectedItems);
        const allItemsSelected = selectedItemKeys.map((key) => this.selectedItems[key].id).every((value) => value);

        selectedItemKeys.forEach((_key, index) => {
            console.log(this.selectedItems[_key]);
            const selectedItemValue = this.selectedItems[_key].id;
            const selectedItemTitle = this.selectedItems[_key].title;

            const accordion = [...this.accordionItems][index];
            if (selectedItemTitle) {
                const displayTitle = selectedItemTitle.replace(/\s*\/\s*/g, ' ');
                accordion.querySelector('.js-product-title').textContent = `- ${displayTitle}`;
            }
            const optionItems = accordion.querySelectorAll('.js-builder-option');

            optionItems.forEach((item) => {
                const itemVariant = item.dataset.attr;
                item.classList.toggle('product-builder__option--active', selectedItemValue === itemVariant);
            });
        });

        if (allItemsSelected) {
            this.builderFormAddToCartButton.removeAttribute('disabled');
        } else {
            this.builderFormAddToCartButton.setAttribute('disabled', 'disabled');
        }
    }

    updateCart(data) {
        // sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.cart, {
        //     event: 'add_to_cart',
        //     products: [data],
        // });

        this.cart.setActiveElement(document.activeElement);
        this.cart.renderContents(data);
    }

    handleSelection(event) {
        event.preventDefault();

        const builderOption = event.target;
        if (!builderOption) {
            this.handleError();
            return;
        }

        const accordionItem = builderOption.closest('.js-accordion-item');
        if (!accordionItem) {
            this.handleError();
            return;
        }

        const selectedKeys = Object.keys(this.selectedItems);
        const selectedIndex = parseInt(accordionItem.dataset.index);
        const selectedItem = this.selectedItems[selectedKeys[selectedIndex]];

        selectedItem.id = builderOption.dataset.attr;
        selectedItem.title = builderOption.dataset.title;

        this.updateUI();

        // Function defined in the Accordion Component
        this.closeAll();
    }

    handleFormSubmission(event) {
        event.preventDefault();

        this.processProducts(this.updateCart.bind(this));
    }

    handleError(error) {
        this.builderError.classList.add('global-message--active');
        throw new Error(error || 'Something went wrong');
    }
}

if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
}
